import React from 'react';
import { Typography } from '@material-ui/core';
import Stack from '@mui/material/Stack';

export const About6 = () => {
  return (
    <div className="about-main-container">
      <div className="about-cover about-6-image" />
      <div className="container">
        <Stack spacing={3} className="about-stack about-6-stack">
          <div className="about-title">It’s in your hands</div>
          <Typography className="about-description">
            Getting on the platform is a straightforward process and you don’t
            need crypto to start. And, remember, with MusicArt, there is no
            filter, gatekeeper, or judge keeping your music from anyone. As long
            as you have the rights to your music, and the time and drive to
            engage with new and innovative marketing tools, you will find a
            welcoming home on MusicArt.
          </Typography>
          <Typography className="about-footer">
            After all, musicians are why MusicArt exists in the first place.
            We’re founded by fans and industry veterans.
          </Typography>
        </Stack>
      </div>{' '}
    </div>
  );
};
